<template>
  <div class='EnbBlacklist'>
    <cont-actions>
      <adm-search place="subdomínio" @run="newValue => search(newValue)"/>
      <adm-btn text="Adicionar" @click="$router.push('/enb/workspace/addblacklist')"/>
      <adm-btn text="Excluir" color="red" @click="del"/>
    </cont-actions>
    <adm-header
    :headers="headers"
    :list="data"
    @toggle="newValue => newValue ? ListItemSelectedPush(data) : ListItemSelectedDel(data)"
    />
    <div class="cont-list">
      <list-item
      v-for="(d, key) in data"
      :key="key"
      :chave="key"
      :headers="headers_data"
      :data="d"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ContActions from '../topActions/ContActions'
import AdmHeader from '../header/AdmHeader'
import ListItem from '../ListItem'
import AdmSearch from '../topActions/AdmSearch'
import AdmBtn from '../topActions/AdmBtn'
export default {
  name: 'EnbBlacklist',
  components: { ContActions, AdmHeader, ListItem, AdmSearch, AdmBtn },
  data () {
    return {
      headers: [
        { text: 'subdomínio', width: '50%' }
      ],
      headers_data: [
        { chave: 'text', width: '50%' }
      ],
      data: [{ id: 1, text: 'adm' }]
    }
  },
  computed: {
    ...mapGetters(['listItemSelected'])
  },
  methods: {
    ...mapActions(['GetBlacklist', '_DeleteBlacklist', 'ListItemSelectedPush', 'ListItemSelectedDel', 'GetSubscriptionEmail']),
    search (text) {
       this.GetBlacklist(text)
         .then(res => {
           this.data = res
         })
    },
    del () {
      if(!this.listItemSelected.length) {
        return
      }
      this._DeleteBlacklist(this.listItemSelected)
        .then(() => this.GetBlacklist(''))
        .then(res => {
          this.data = res
        })
    }
  },
  created () {
    this.GetBlacklist('')
      .then(res => {
        this.data = res
      })
  }
}
</script>

<style scoped>
.EnbBlacklist {
  width: 100%;
  height: 96%;
}
.cont-list{
  width: 100%;
  height: 89%;
}
</style>
